import React, { useEffect, useState } from 'react';
import { Clock } from 'lucide-react';
export function Countdown() {
  // Set a fixed countdown for the session (e.g., 23 hours, 59 mins, 59 secs)
  const [timeLeft, setTimeLeft] = useState({
    hours: 23,
    minutes: 59,
    seconds: 59
  });
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        if (prev.seconds > 0) {
          return {
            ...prev,
            seconds: prev.seconds - 1
          };
        } else if (prev.minutes > 0) {
          return {
            ...prev,
            minutes: prev.minutes - 1,
            seconds: 59
          };
        } else if (prev.hours > 0) {
          return {
            hours: prev.hours - 1,
            minutes: 59,
            seconds: 59
          };
        }
        return prev; // Timer ended
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const formatNumber = (num: number) => num.toString().padStart(2, '0');
  return <div className="bg-trek-brown border-y border-trek-orange/30 py-6 px-4" data-id="element-31">
      <div className="max-w-3xl mx-auto flex flex-col sm:flex-row items-center justify-center gap-4 sm:gap-8" data-id="element-32">
        <div className="flex items-center gap-2 text-white font-bold text-lg" data-id="element-33">
          <Clock className="text-trek-orange animate-pulse" data-id="element-34" />
          <span data-id="element-35">⏰ ESTA OFERTA VENCE EN:</span>
        </div>

        <div className="flex items-center gap-3" data-id="element-36">
          <div className="flex flex-col items-center" data-id="element-37">
            <div className="bg-trek-black text-trek-orange font-display text-3xl sm:text-4xl px-4 py-2 rounded-lg min-w-[70px] text-center shadow-inner" data-id="element-38">
              {formatNumber(timeLeft.hours)}
            </div>
            <span className="text-trek-beige/70 text-xs mt-1 font-bold" data-id="element-39">
              HORAS
            </span>
          </div>
          <span className="text-trek-orange font-display text-3xl pb-5" data-id="element-40">:</span>
          <div className="flex flex-col items-center" data-id="element-41">
            <div className="bg-trek-black text-trek-orange font-display text-3xl sm:text-4xl px-4 py-2 rounded-lg min-w-[70px] text-center shadow-inner" data-id="element-42">
              {formatNumber(timeLeft.minutes)}
            </div>
            <span className="text-trek-beige/70 text-xs mt-1 font-bold" data-id="element-43">
              MIN
            </span>
          </div>
          <span className="text-trek-orange font-display text-3xl pb-5" data-id="element-44">:</span>
          <div className="flex flex-col items-center" data-id="element-45">
            <div className="bg-trek-black text-trek-orange font-display text-3xl sm:text-4xl px-4 py-2 rounded-lg min-w-[70px] text-center shadow-inner" data-id="element-46">
              {formatNumber(timeLeft.seconds)}
            </div>
            <span className="text-trek-beige/70 text-xs mt-1 font-bold" data-id="element-47">
              SEG
            </span>
          </div>
        </div>
      </div>
    </div>;
}